<template>
  <div>
    <div class="title">
      日期时间选择器配置
    </div>
    <div class="margin_container">
      <el-radio-group v-model="selectVal.optionsValue">
        <el-radio
          v-for="item in date_type"
          :key="item.label"
          :label="item.label"
        >
          {{
            item.title
          }}
        </el-radio>
      </el-radio-group>
    </div>
  </div>
</template>
<script>
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpSelectDateConfig',
  mixins: [mixin],
  data () {
    return {
      selectVal: {
        optionsValue: 'YMD'
      },
      date_type: [
        {
          'title': '年/月/日',
          'label': 'YMD'
        },
        {
          'title': '年/月/日/时/分',
          'label': 'YMDHM'
        },
        {
          'title': '时/分',
          'label': 'HM'
        }
      ]
    }
  },
  watch: {},
  created () {},
  methods: {}
}
</script>
<style scoped lang="scss">
.title {
  font-size: 16px;
}
.margin_container {
  display: flex;
  margin-top: 15px;
}
</style>
